import cn from 'classnames';
import { Link } from 'react-router-dom';
import LeftArrowIcon from '@/shared/assets/icons/education/Chevron_Left.svg';
import RightArrowIcon from '@/shared/assets/icons/education/Chevron_Right.svg';
import { Svg } from '@/shared/ui/Svg';
import { ILessonNavigation, LessonTypeEnum } from '@/shared/types/lesson';


interface LessonNavCardProps {
  direction: 'prev' | 'next';
  lesson: ILessonNavigation | null;
  to: string | null;
}

export const LessonNavCard = ({ direction, lesson, to }: LessonNavCardProps) => {
  const isDisabled = !lesson || !to;

  const base = 'flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm';
  const enabled = 'hover:bg-gray-50 transition';
  const disabled = 'opacity-50 cursor-not-allowed';

  const label = direction === 'prev' ? 'Previous session' : 'Next session';

  const content = (
    <div className={cn(base, !isDisabled && enabled, isDisabled && disabled)}>
      {!isDisabled && direction === 'prev' && (
        <div className="shrink-0 text-gray-400">
          <Svg Icon={LeftArrowIcon} />
        </div>
      )}
      <div className="flex-auto">
        <div className="text-xs text-gray-500">{label}</div>
        <div className="truncate font-medium text-gray-900">
          {lesson ? `${lesson.order}. ${lesson.title}` : '—'}
          {lesson?.groupExamResubmissionId ? (
            <span className="ml-2 text-xs text-gray-500">(Resubmission)</span>
          ) : lesson?.type === LessonTypeEnum.Exam ? (
            <span className="ml-2 text-xs text-gray-500">(Exam)</span>
          ) : null}
        </div>
      </div>
      {!isDisabled && direction === 'next' && (
        <div className="shrink-0 text-gray-400">
          <Svg Icon={RightArrowIcon} />
        </div>
      )}
    </div>
  );

  if (isDisabled) return <div>{content}</div>;
  return (
    <Link to={to} aria-label={label}>
      {content}
    </Link>
  );
};
